var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClient from '@utils/api-client';
// `update_action` values `#bulk_update` switches on — must match
// `Api::Internal::Inspections::InspectionAttachmentsController::UPDATE_ACTION_*` exactly.
const BULK_UPDATE_ACTION_ANSWER = 'answer';
const BULK_UPDATE_ACTION_REPORT_OPTIONS = 'report_options';
/**
 * Fetches every attachment for an inspection in one request.
 *
 * Unlike Building's index this endpoint is NOT paginated — it renders the whole ordered relation —
 * so there is no `select[all]=true` to send. If it ever gains pagination, this call has to opt out
 * of it explicitly: a silently truncated payload is how the Building e2e suite ended up asserting
 * "50 before and after" regardless of what the server did (task-10).
 */
export function fetchInspectionAttachments(inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.get(`/api/internal/inspections/${inspectionId}/inspection_attachments`);
        return response.data;
    });
}
/**
 * Single-field partial payload (the inline-edit cells never send more than one key), returning the
 * full server-confirmed row. `apiClient`'s case-converter turns `inspectionAttachment` into the
 * `inspection_attachment` param key Rails requires.
 */
export function updateInspectionAttachment(inspectionId, attachmentId, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.patch(`/api/internal/inspections/${inspectionId}/inspection_attachments/${attachmentId}`, { inspectionAttachment: payload });
        return response.data;
    });
}
/**
 * Mass "Update result". `answer` is the enum value, or `null`/'' to clear the result back to None —
 * the controller normalises blank to NULL because assigning "" to a Rails enum raises.
 */
export function bulkUpdateAttachmentResult(inspectionId, ids, answer) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.patch(`/api/internal/inspections/${inspectionId}/inspection_attachments/bulk_update`, { ids, updateAction: BULK_UPDATE_ACTION_ANSWER, answer });
        return response.data;
    });
}
/**
 * Mass "Update report options". Only the keys supplied are written, so either checkbox can be set
 * without clobbering the other — the controller selects on `params.key?`.
 */
export function bulkUpdateAttachmentReportOptions(inspectionId, ids, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.patch(`/api/internal/inspections/${inspectionId}/inspection_attachments/bulk_update`, Object.assign({ ids, updateAction: BULK_UPDATE_ACTION_REPORT_OPTIONS }, options));
        return response.data;
    });
}
/**
 * Mass destroy. Always sends explicit ids: this endpoint treats absent AND empty as "no rows", so
 * a cleared selection can never delete the whole inspection's attachments.
 */
export function bulkDestroyAttachments(inspectionId, ids) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.delete(`/api/internal/inspections/${inspectionId}/inspection_attachments/bulk_destroy`, { data: { ids } });
        return response.data;
    });
}
/** Single-row destroy, used by the row delete icon. */
export function destroyAttachment(inspectionId, attachmentId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`/api/internal/inspections/${inspectionId}/inspection_attachments/${attachmentId}`);
    });
}
